export function nextState({ store, reducer, action }) {
  const currentReducer = reducer(action);
  if (currentReducer[action.type]) {
    const state = store.getValue();
    const newState = currentReducer[action.type](state);
    store.next({ ...state, ...newState });
  }
}
